import { Phone } from "lucide-react";
import { MessageComposer, MessageList, useTripComms } from "@/components/TripChat";
import { fmtDate } from "@/lib/api";

export const TripComms = ({ trip, user }) => {
  const [{ messages, calls, read_only }, reload] = useTripComms(trip.id, 5000);
  const myRole = user.role;
  return (
    <div className="grid gap-6 lg:grid-cols-[1.4fr_1fr]" data-testid="trip-comms">
      <div className="lux-card p-5 sm:p-6">
        <div className="mb-4 flex items-center justify-between">
          <p className="lux-eyebrow">Conversation</p>
          {read_only && <span data-testid="conversation-read-only" className="text-xs text-zinc-500">Read-only</span>}
        </div>
        <div className="max-h-96 overflow-y-auto pr-1"><MessageList messages={messages} myRole={myRole} /></div>
        {!read_only && <div className="mt-4"><MessageComposer tripId={trip.id} onSent={reload} testPrefix="detail-chat" /></div>}
        {!read_only && myRole === "admin" && <p className="mt-2 text-xs text-zinc-500">Your messages are labelled "Luxury Rideshare".</p>}
      </div>
      <div className="lux-card p-5 sm:p-6" data-testid="call-log">
        <p className="lux-eyebrow mb-4">Call log</p>
        {calls.length === 0 && <p className="text-sm text-zinc-500">No calls.</p>}
        {calls.map((c) => (
          <div key={c.id} data-testid="call-log-entry" className="flex items-start gap-3 border-b border-white/5 py-2.5 text-sm last:border-0">
            <Phone className="mt-0.5 h-4 w-4 text-amber-400" />
            <div><p className="text-zinc-200">{c.caller_name} → {c.callee_name}</p><p className="text-xs text-zinc-500">{fmtDate(c.created_at)}</p></div>
          </div>
        ))}
      </div>
    </div>
  );
};
